/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */
import type { ImportReportDtoStatus } from './importReportDtoStatus';
import type { ImportReportDtoAnimalType } from './importReportDtoAnimalType';
import type { ImportReportDtoWildType } from './importReportDtoWildType';
import type { ImportReportDtoSurveillanceType } from './importReportDtoSurveillanceType';
import type { ImportReportDtoHumanAffected } from './importReportDtoHumanAffected';
import type { ImportReportDtoDomesticAnimalAffected } from './importReportDtoDomesticAnimalAffected';
import type { DiagnosticProcedureBodyDto } from './diagnosticProcedureBodyDto';

export interface ImportReportDto {
  /** Publication status of the report */
  status?: ImportReportDtoStatus;
  /** Type of animal */
  animalType?: ImportReportDtoAnimalType;
  specie?: string;
  /** Wild type */
  wildType?: ImportReportDtoWildType;
  latitude?: number;
  longitude?: number;
  /** Inaccurate location flag */
  inaccurateLocation?: boolean;
  /** Detection date */
  detectionDate?: string;
  /** Surveillance type */
  surveillanceType?: ImportReportDtoSurveillanceType;
  description?: string;
  numberOfDeaths?: number;
  numberOfSicks?: number;
  populationSize?: number;
  /** Human affected */
  humanAffected?: ImportReportDtoHumanAffected;
  /** Domestic animal affected */
  domesticAnimalAffected?: ImportReportDtoDomesticAnimalAffected;
  knownCause?: boolean;
  order?: string;
  etiologyTypeCode?: string;
  etiologicalAgentCode?: string;
  /** Diagnostic procedures */
  diagnosticProcedures?: DiagnosticProcedureBodyDto[];
}
